import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Box,
  Button,
  Avatar,
  Divider,
  Grid,
  Chip,
  Stack,
  IconButton,
  Tooltip
} from '@mui/material';
import { ArrowBack as ArrowBackIcon, Edit as EditIcon, MeetingRoom as MeetingRoomIcon, OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import { meetingsData } from '../../Data/Kontak/Meeting';
import Swal from 'sweetalert2';
import { SwalConfig } from '../../utils/swalConfig';

const ViewMeeting = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [item, setItem] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem('meetings');
    const list = stored ? JSON.parse(stored) : meetingsData;
    const found = list.find(x => x.id === id || x._id === id);
    if (!found) {
      Swal.fire({ ...SwalConfig.error, title: 'Not found', text: 'Pengajuan meeting tidak ditemukan' });
      navigate('/kontak/meeting');
      return;
    }
    setItem(found);
  }, [id, navigate]);

  if (!item) return null;

  const statusColor = (s) => {
    if (!s) return 'default';
    const v = s.toLowerCase();
    if (v === 'approved' || v === 'accepted' || v === 'approved') return 'success';
    if (v === 'rejected' || v === 'cancelled') return 'error';
    return 'warning';
  };

  return (
    <Card sx={{ borderRadius: 3, boxShadow: '0 8px 32px rgba(0,0,0,0.06)' }}>
      <CardHeader
        avatar={(
          <Avatar sx={{ bgcolor: 'primary.main', width: 56, height: 56 }}>
            <MeetingRoomIcon />
          </Avatar>
        )}
        title={<Typography variant="h4" sx={{ fontWeight: 700 }}>Detail Pengajuan Meeting</Typography>}
        subheader={<Typography variant="body2" sx={{ color: 'text.secondary' }}>{item.requesterName} • {item.room}</Typography>}
        action={(
          <Stack direction="row" spacing={1} alignItems="center">
            <Tooltip title="Buka link publik">
              <IconButton onClick={() => { navigator.clipboard?.writeText(window.location.href); Swal.fire({ ...SwalConfig.success, title: 'Link disalin', text: 'Link halaman telah disalin ke clipboard.' }); }}>
                <OpenInNewIcon />
              </IconButton>
            </Tooltip>
            <Button startIcon={<EditIcon />} variant="contained" onClick={() => navigate(`/kontak/meeting/edit/${item.id}`)}>Edit</Button>
            <Button startIcon={<ArrowBackIcon />} variant="outlined" onClick={() => navigate('/kontak/meeting')}>Kembali</Button>
          </Stack>
        )}
      />
      <Divider />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box>
                <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>Tanggal</Typography>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>{item.date}</Typography>
              </Box>
              <Box>
                <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>Waktu</Typography>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>{item.startTime} — {item.endTime}</Typography>
              </Box>
              <Box>
                <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>Jumlah Peserta</Typography>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>{item.attendees}</Typography>
              </Box>
              <Box>
                <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>Ruangan</Typography>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>{item.room}</Typography>
              </Box>
              <Box>
                <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>Status</Typography>
                <Chip label={item.status || 'Pending'} color={statusColor(item.status)} sx={{ fontWeight: 700 }} />
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box>
                <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>Keperluan</Typography>
                <Typography variant="body1" sx={{ fontSize: '1rem' }}>{item.purpose || '-'}</Typography>
              </Box>
              <Box>
                <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>Catatan</Typography>
                <Typography variant="body2" sx={{ background: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.03)' : '#f7fafc', p: 2, borderRadius: 1 }}>{item.notes || '-'}</Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ViewMeeting;
